module.exports = "<div id='spacersm'></div>\r\n<div align='center' >\r\n<hr>\r\n<span class='footer'> © 2017 General Information Services, Inc. - All rights reserved.</span>\r\n</div>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/footer.component.html
// module id = ./src/app/footer/footer.component.html
// module chunks = app